import { render, staticRenderFns } from "./CatalogoDigitalSettingsTab.vue?vue&type=template&id=0bae731f&scoped=true"
import script from "./CatalogoDigitalSettingsTab.vue?vue&type=script&lang=js"
export * from "./CatalogoDigitalSettingsTab.vue?vue&type=script&lang=js"
import style0 from "./CatalogoDigitalSettingsTab.vue?vue&type=style&index=0&id=0bae731f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bae731f",
  null
  
)

export default component.exports